import { NavLink } from 'react-router-dom';
import {
    Building2,
    LayoutList,
    BarChart3,
    Wrench,
    Headphones,
    FileText,
    Users,
    Settings,
    Wallet,
    ChevronRight,
} from 'lucide-react';

const navItems = [
    { to: '/', icon: LayoutList, label: '단지 목록' },
    { to: '/dashboard', icon: BarChart3, label: '대시보드' },
    { to: '/payments', icon: Wallet, label: '결제 정보' },
    { to: '#', icon: Wrench, label: '세팅 로그' },
    { to: 'https://redmine.mytown.cc', icon: Headphones, label: 'CS 로그' },
    { to: '#', icon: FileText, label: '계약 관리' },
    { to: '#', icon: Users, label: '담당자 관리' },
    { to: '/settings', icon: Settings, label: '설정' },
];

export default function Sidebar() {
    const userStr = sessionStorage.getItem('user');
    const user = userStr ? JSON.parse(userStr) : null;
    const displayName = user?.username || '사용자';
    const roleLabel = user?.role === 'viewer' ? '조회전용' : '편집자';
    const initial = displayName.charAt(0).toUpperCase();

    const handleLogout = () => {
        sessionStorage.removeItem('token');
        sessionStorage.removeItem('user');
        window.location.href = '/login';
    };

    return (
        <aside className="fixed top-0 left-0 w-[230px] h-screen bg-[#2A3F54] text-[#E7E7E7] flex flex-col z-50 shadow-xl">
            {/* 프로필 영역 */}
            <div className="px-5 pt-5 pb-4">
                <div className="flex items-center gap-3">
                    <div className="w-11 h-11 rounded-full bg-white/20 flex items-center justify-center text-sm font-bold text-white ring-2 ring-white/30">
                        {initial}
                    </div>
                    <div className="flex-1 min-w-0">
                        <div className="text-[13px] font-semibold text-white truncate">{displayName}</div>
                        <div className="text-[11px] text-[#BAB8B8]">{roleLabel}</div>
                    </div>
                    <button
                        onClick={handleLogout}
                        className="p-1.5 rounded hover:bg-white/10 transition"
                        title="로그아웃"
                    >
                        <ChevronRight className="w-4 h-4 text-[#73879C] rotate-180" />
                    </button>
                </div>
            </div>

            {/* 구분선 */}
            <div className="mx-4 border-t border-[#416180]" />

            {/* 로고/타이틀 */}
            <div className="px-5 py-3 flex items-center gap-2">
                <Building2 className="w-5 h-5 text-[#73879C]" />
                <span className="text-xs font-bold uppercase tracking-widest text-[#73879C]">KYS 단지관리</span>
            </div>

            {/* 네비게이션 */}
            <nav className="flex-1 px-0 overflow-y-auto">
                {navItems.map((item) => {
                    const Icon = item.icon;
                    if (item.to === '#') {
                        return (
                            <span
                                key={item.label}
                                className="flex items-center gap-3 px-5 py-[10px] text-[13px] text-[#E7E7E7] hover:bg-[#1A2D3F] cursor-pointer transition border-l-[3px] border-transparent"
                            >
                                <Icon className="w-[18px] h-[18px] text-[#73879C]" />
                                <span className="flex-1">{item.label}</span>
                                <ChevronRight className="w-3.5 h-3.5 text-[#73879C]" />
                            </span>
                        );
                    }
                    if (item.to.startsWith('http')) {
                        return (
                            <a
                                key={item.label}
                                href={item.to}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="flex items-center gap-3 px-5 py-[10px] text-[13px] text-[#E7E7E7] hover:bg-[#1A2D3F] transition border-l-[3px] border-transparent"
                            >
                                <Icon className="w-[18px] h-[18px] text-[#73879C]" />
                                <span className="flex-1">{item.label}</span>
                            </a>
                        );
                    }
                    return (
                        <NavLink
                            key={item.label}
                            to={item.to}
                            end={item.to === '/'}
                            className={({ isActive }) =>
                                `flex items-center gap-3 px-5 py-[10px] text-[13px] transition border-l-[3px] ${isActive
                                    ? 'bg-[#1A2D3F] text-white border-[#1ABB9C] font-medium'
                                    : 'text-[#E7E7E7] hover:bg-[#1A2D3F] border-transparent'
                                }`
                            }
                        >
                            {({ isActive }) => (
                                <>
                                    <Icon className={`w-[18px] h-[18px] ${isActive ? 'text-[#1ABB9C]' : 'text-[#73879C]'}`} />
                                    <span className="flex-1">{item.label}</span>
                                </>
                            )}
                        </NavLink>
                    );
                })}
            </nav>

            {/* 하단 */}
            <div className="px-5 py-3 border-t border-[#416180]">
                <div className="text-[10px] text-[#73879C]">© 2026 KYS Town Manager</div>
            </div>
        </aside>
    );
}
